(function () {
  const WEBHOOK_URL =
    'https://fawad.n8npixel.cloud/webhook/zeshopia/analytics/event';

  function getUTM() {
    const p = new URLSearchParams(window.location.search);

    return {
      utm_source: p.get('utm_source'),
      utm_medium: p.get('utm_medium'),
      utm_campaign: p.get('utm_campaign'),
      utm_content: p.get('utm_content'),
      utm_term: p.get('utm_term')
    };
  }

  function getSessionId() {
    let id = sessionStorage.getItem('zeshopia_session_id');

    if (!id) {
      id =
        Date.now().toString(36) +
        '-' +
        Math.random().toString(36).substring(2, 10);

      sessionStorage.setItem('zeshopia_session_id', id);
    }

    return id;
  }

  function sendEvent(eventName, extra) {
    const utm = getUTM();

    const payload = {
      event_ts: new Date().toISOString(),
      event_name: eventName,
      session_id: getSessionId(),

      page_path: window.location.href,
      referrer: document.referrer || null,
      language:
        document.documentElement.lang ||
        navigator.language ||
        null,
      user_agent: navigator.userAgent,

      ...utm,
      ...(extra || {})
    };

    try {
      const formBody = new URLSearchParams();

      formBody.set(
        'payload',
        JSON.stringify(payload)
      );

      fetch(WEBHOOK_URL, {
        method: 'POST',
        mode: 'no-cors',
        credentials: 'omit',
        body: formBody,
        keepalive: true
      }).catch(() => {});
    } catch (e) {
      console.warn(
        'Zeshopia analytics error:',
        e
      );
    }
  }

  // Save UTM attribution for later pages
  const initialUTM = getUTM();

  Object.keys(initialUTM).forEach((key) => {
    if (initialUTM[key]) {
      sessionStorage.setItem(
        key,
        initialUTM[key]
      );
    }
  });

  function getStoredUTM() {
    return {
      utm_source:
        sessionStorage.getItem('utm_source'),

      utm_medium:
        sessionStorage.getItem('utm_medium'),

      utm_campaign:
        sessionStorage.getItem('utm_campaign'),

      utm_content:
        sessionStorage.getItem('utm_content'),

      utm_term:
        sessionStorage.getItem('utm_term')
    };
  }

  function sendTrackedEvent(
    eventName,
    extra
  ) {
    const stored = getStoredUTM();

    sendEvent(eventName, {
      ...stored,
      ...(extra || {})
    });
  }

  // --------------------------------------------------
  // PAGE + PRODUCT VIEW
  // --------------------------------------------------

  let initialPageTracked = false;
  let productViewSent = false;

 function sendProductViewWhenReady(attempt = 0) {
  if (productViewSent) {
    return;
  }

  if (window.ZESHOPIA_PRODUCT) {
    const product = window.ZESHOPIA_PRODUCT;

    const viewKey =
      'zeshopia_product_view_' +
      String(product.handle || product.id);

    // Do not record the same product more than once
    // during the current browser session.
    if (sessionStorage.getItem(viewKey)) {
      productViewSent = true;
      return;
    }

    sessionStorage.setItem(viewKey, '1');
    productViewSent = true;

    sendTrackedEvent('product_view', {
      product_id: product.id || null,
      product_handle: product.handle || null,
      sku: product.sku || null,
      value_sar: Number(product.price || 0),
      quantity: 1
    });

    return;
  }

  // Retry for approximately 5 seconds
  if (attempt < 20) {
    setTimeout(function () {
      sendProductViewWhenReady(attempt + 1);
    }, 250);
  }
}

  function trackInitialPage() {
    if (initialPageTracked) {
      return;
    }

    initialPageTracked = true;

    sendTrackedEvent('page_view');

    sendProductViewWhenReady();
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      trackInitialPage,
      { once: true }
    );
  } else {
    trackInitialPage();
  }

  // --------------------------------------------------
  // ADD TO CART
  // --------------------------------------------------

  document.addEventListener(
    'submit',
    function (e) {
      const form = e.target;

      if (
        form &&
        form.action &&
        form.action.indexOf(
          '/cart/add'
        ) !== -1
      ) {
        const qtyField =
          form.querySelector(
            '[name="quantity"]'
          );

        const quantity =
          qtyField
            ? Number(
                qtyField.value || 1
              )
            : 1;

        sendTrackedEvent(
          'add_to_cart',
          {
            product_id:
              window
                .ZESHOPIA_PRODUCT
                ?.id || null,

            product_handle:
              window
                .ZESHOPIA_PRODUCT
                ?.handle || null,

            sku:
              window
                .ZESHOPIA_PRODUCT
                ?.sku || null,

            value_sar:
              Number(
                window
                  .ZESHOPIA_PRODUCT
                  ?.price || 0
              ),

            quantity
          }
        );
      }
    }
  );

  // --------------------------------------------------
  // BEGIN CHECKOUT
  // --------------------------------------------------

  document.addEventListener(
    'click',
    function (e) {
      const el =
        e.target.closest(
          'a[href*="/checkout"], button[name="checkout"], input[name="checkout"]'
        );

      if (el) {
        sendTrackedEvent(
          'begin_checkout'
        );
      }
    }
  );
})();